<template>
  <div v-if="!animate" class="question__answer-item-result">
    {{ value }}
  </div>
  <div v-if="animate" class="question__answer-item-result">
    <span> {{ result }}</span>
    <span v-if="resultType === ResultType.PERCENTAGE">%</span>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, onMounted, ref } from 'vue';
import { ResultType } from '@/src/components/games/poll/Enums';

export default defineComponent({
  name: 'AnswerResult',
  components: {},
  props: {
    value: {
      type: [Number, String]
    },
    count: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      required: true
    },
    delay: {
      type: Number,
      required: true
    },
    resultType: String as PropType<ResultType>,
    animate: Boolean
  },
  setup(props) {
    const result = ref('0');
    const increment = ref(0);
    let interval: number | null = null;
    const updatedValue = ref(0);

    const percentageType = props.resultType === ResultType.PERCENTAGE;

    const start = () => {
      increment.value = Number(props.value) / (props.duration / 30);

      interval = window.setInterval(function () {
        updatedValue.value += increment.value;

        if (updatedValue.value >= Number(props.value)) {
          updatedValue.value = Number(props.value);

          if (interval) {
            clearInterval(interval);
          }
          result.value = parseFloat(updatedValue.value + '').toFixed(percentageType ? 1 : 0);
        } else {
          result.value = parseFloat(updatedValue.value + '').toFixed(percentageType ? 1 : 0);
        }
      }, 30);
    };

    onMounted(() => {
      if (props.value) {
        if (props.delay > 0) {
          window.setTimeout(function () {
            start();
          }, props.delay);
        } else {
          start();
        }
      }
    });

    return {
      result,
      ResultType
    };
  }
});
</script>
